import {useActions} from "state/hooks";
import {logger} from "joynt/state/actions/meetings";

export default function useLogger() {
    const {log} = useActions({log: logger});
    return log;
}